import React from 'react';
import Loadable from 'react-loadable';
import Loader from '../../../../utils/Loader';

const ForgotPasswordLoadable = Loadable({
    loader: () => import('../index' /* webpackChunkName: "Authentication" */),
    loading() {
        return <Loader />;
    },
});

export default ForgotPasswordLoadable;
